import {path} from './path';

export const url = id => `url(${path(id)})`;
